<div class="d-inline-block country-select">
  <button type="button" class="text-link country-select__toggle" id="countrySelect" (click)="isDropdownOpen = !isDropdownOpen">
    <i class="fal fa-globe"></i>
    @if (!selectedCountry) {
      <span>Select your country</span>
    }
    @if (selectedCountry) {
      <span>{{ selectedCountry.label[localeId] }}</span>
    }
    <i class="fal fa-chevron-down" [ngClass]="{ rotate: isDropdownOpen }"></i>
  </button>
  @if (isDropdownOpen) {
    <div aria-labelledby="countrySelect" class="country-select__dropdown">
      @for (country of countries; track country) {
        <a class="dropdown-item" [ngClass]="{ active: country.checked }" [href]="country.link">
          <span>{{ country.label[localeId] }}</span>
        </a>
      }
    </div>
  }
</div>
@if (isDropdownOpen) {
  <div
    class="dropdown-backdrop"
    tabindex="-1"
    (click)="isDropdownOpen = !isDropdownOpen"
    (keypress)="isDropdownOpen = !isDropdownOpen"
  ></div>
}
